import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment'

@Injectable({
  providedIn: 'root'
})
export class MyAppointmentsService {
    constructor(private http: HttpClient, private router: Router) { }


appointmentList(){
    return this.http.get(checkUrl()+"/admin/appointment")
    .pipe((response)=>{
          return response;
    })
  }
}
